import { format, parseISO } from 'date-fns'
import type { TimelineActivity } from '@/frontend/features/Fde/types'

export interface TimelineActivityGroup {
  id: string
  items: TimelineActivity[]
}

function activityDay(activity: TimelineActivity) {
  return format(parseISO(activity.occurred_at), 'yyyy-MM-dd')
}

function belongsToGroup(group: TimelineActivityGroup, activity: TimelineActivity) {
  const previous = group.items[group.items.length - 1]

  return previous.kind === activity.kind
    && previous.actor_name === activity.actor_name
    && previous.actor_avatar_url === activity.actor_avatar_url
    && activityDay(previous) === activityDay(activity)
}

export function groupTimelineActivities(activities: TimelineActivity[]) {
  return activities.reduce<TimelineActivityGroup[]>((groups, activity) => {
    const current = groups[groups.length - 1]

    if (current && belongsToGroup(current, activity)) {
      current.items.push(activity)
      return groups
    }

    groups.push({ id: activity.id, items: [activity] })
    return groups
  }, [])
}
